import { USER_INPUT_GETALL_COLUMNS_TYPE_SUCCESS } from "../../../../Constant/ApaManagement/ApaPreparationByUser/WorkPlanTable/UserInputGetAllColumnsConstant";


export const UserInputGetAllColumnsReducer = (state = { userInputAllColumnslist: [] }, action) => {

    switch (action.type) {
        case USER_INPUT_GETALL_COLUMNS_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                userInputAllColumnslist: action.payload


            }

        default:
            return state
    }


};
